module.exports = __webpack_public_path__ + "img/card-avatar-gold.be20e1fd.png";